"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAssetDownload = useAssetDownload;
const react_1 = __importDefault(require("react"));
const axios_1 = __importDefault(require("axios"));
const jszip_1 = __importDefault(require("jszip"));
const file_saver_1 = require("file-saver");
const Api = __importStar(require("@src/api"));
const types_1 = require("@src/types");
const get_cdn_image_url_1 = require("@src/shared/get-cdn-image-url");
const use_asset_library_notifications_1 = require("./use-asset-library-notifications");
function useAssetDownload() {
    const [isDownloadingAssets, setIsDownloadingAssets] = react_1.default.useState(false);
    const { showGeneralErrorNotification } = (0, use_asset_library_notifications_1.useAssetLibraryNotifications)();
    const getDOcumentAssetBlob = async (downloadUrl) => {
        const response = await axios_1.default.get(downloadUrl, { responseType: 'blob' });
        return response.data;
    };
    const getImageAssetBlob = async (cloudinaryPublicId) => {
        const assetImageUrl = (0, get_cdn_image_url_1.getCdnImageUrl)({
            file: cloudinaryPublicId,
            shouldIncludeEnvironmentPart: false,
            addWatermarkedLogo: true,
        });
        const response = await axios_1.default.get(assetImageUrl, { responseType: 'blob' });
        return response.data;
    };
    const getVideoAssetBlob = async (muxAssetId) => {
        const downloadUrl = await Api.Asset.waitForVideoMp4VersionToBeProcessedAndGetDownloadUrl(muxAssetId);
        const response = await axios_1.default.get(downloadUrl, { responseType: 'blob' });
        return response.data;
    };
    const downloadAndSaveAssets = async (assets) => {
        try {
            setIsDownloadingAssets(true);
            const zip = new jszip_1.default();
            await Promise.all(assets.map(async (asset) => {
                if (asset.type === types_1.AssetType.DOCUMENT) {
                    const documentAssetBlob = await getDOcumentAssetBlob(asset.url);
                    zip.file(asset.filename, documentAssetBlob);
                }
                if (asset.type === types_1.AssetType.IMAGE) {
                    const imageAssetBlob = await getImageAssetBlob(asset.cloudinaryPublicId);
                    zip.file(asset.filename, imageAssetBlob);
                }
                if (asset.type === types_1.AssetType.VIDEO) {
                    const videoAssetBlob = await getVideoAssetBlob(asset.muxAssetId);
                    zip.file(asset.filename, videoAssetBlob);
                }
            }));
            const zipFile = await zip.generateAsync({ type: 'blob' });
            (0, file_saver_1.saveAs)(zipFile, `pracuj_assets_${Date.now()}.zip`);
        }
        catch (err) {
            console.error(err);
            showGeneralErrorNotification();
        }
        finally {
            setIsDownloadingAssets(false);
        }
    };
    return { downloadAndSaveAssets, isDownloadingAssets };
}
